import axios from 'axios';
import type {
  AnsweringSubscriptionJsonType,
  AnsweringSubscriptionLevel,
} from '@bb/domain/dist/types';

const findActiveSubscription = async (params: {
  subscriptionLevel: AnsweringSubscriptionLevel;
  userId?: string;
}): Promise<AnsweringSubscriptionJsonType | undefined> => {
  const { data } = await axios.get<AnsweringSubscriptionJsonType | undefined>(
    '/answering_service/find_active',
    {
      params,
    },
  );

  if (data) return data;

  return undefined;
};

export default findActiveSubscription;
